export enum ApiIncomeTaxReturnStatus {
  submitted = "submitted",
  accepted = "accepted",
  rejected = "rejected",
  refundReceived = "refund_received",
  noRefund = "no_refund",
}

export interface ApiIncomeTaxReturn {
  taxReturnStatus: ApiIncomeTaxReturnStatus;
  taxYear: number;
  refundAmount: number;
  jurisdiction: string; // 'Federal' or specific state
  createdAt: string;
  updatedAt: string;
  refundAdvanceEligible: boolean;
}

export interface ApiIncomeTaxReturns {
  incomeTaxReturns: ApiIncomeTaxReturn[];
}
